export const environment = {
    production: true,
    apiBaseUrl: 'https://priv.cokaclub.it/api',
    socketBaseUrl: 'https://priv.cokaclub.it',
    timeZone: 'Europe/Rome',
    //Modularità del software
    autoRefresh: true,
    hasStampa: true,
    hasBlockList: false,
    //Orari di apertura e chiusura
    oraApertua: 9,
    minutiApertura: 0,
    oraChiusura: 23,
    minutiChiusura: 0,
  };
